module.exports = __webpack_public_path__ + "img/phone.b8cbbd1b.png";